export const noop = (): void => {
  /* */
};
